import { Config } from "@/shared/config";

const claimServiceUri = Config.ClaimServicebaseUri;

export default {
  get claimServiceV1 () {
    return `${claimServiceUri}/claimservice/v1`;
  },
  getClaims (): string {
    return `${this.claimServiceV1}/claims`;
  },
  getLinkedExpenses (): string {
    return `${this.claimServiceV1}/claims/expenses-by-claim`;
  },
  getClaimLinksByExpense (): string {
    return `${this.claimServiceV1}/claims/claimLinks-by-expense`;
  },
  getLinkedClaims (): string {
    return `${this.claimServiceV1}/claims/claims-by-expense`;
  },
  userHasThirdPartyClaims (): string {
    return `${this.claimServiceV1}/claims/third-party`;
  },
  linkExpenseToClaims (): string {
    return `${this.claimServiceV1}/claims/link-claims`;
  },
  linkClaimToExpenses (): string {
    return `${this.claimServiceV1}/claims/link-expenses`;
  },
  optInHPHC (): string {
    return `${this.claimServiceV1}/claims/opt/in`;
  },
  optOutHPHC (): string {
    return `${this.claimServiceV1}/claims/opt/out`;
  },
  hasClaims (): string {
    return `${this.claimServiceV1}/claims/has-claims`;
  },
  removeClaimExpenseLink (claimNumber: string, expenseId: number): string {
    return `${this.claimServiceV1}/claimexpense/${claimNumber}/${expenseId}`;
  },
  removeLinksToExpense (expenseId: number): string {
    return `${this.claimServiceV1}/claimexpense/expense/${expenseId}`;
  },
};